package com.daytimegaming.ourdailyfinances.domain.billing

import kotlinx.coroutines.flow.StateFlow

sealed class PurchaseState {
    object Idle : PurchaseState()
    object Loading : PurchaseState()
    data class Success(val tier: String, val transactionId: String) : PurchaseState()
    data class Error(val message: String) : PurchaseState()
}

data class SubscriptionProduct(
    val id: String,
    val tier: String,
    val name: String,
    val price: String,
    val description: String
)

interface SubscriptionManager {
    val purchaseState: StateFlow<PurchaseState>
    
    fun setAndroidActivity(activity: Any?)
    
    suspend fun loadProducts(): List<SubscriptionProduct>
    suspend fun buyProduct(productId: String, oldPurchaseToken: String? = null)
    fun openSubscriptionManagement(productId: String? = null)
}
